export const STAT_PERIODS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};

export const STAT_PERIOD_OPTIONS = [
  { value: STAT_PERIODS.DAY, label: 'Day' },
  { value: STAT_PERIODS.WEEK, label: 'Week' },
  { value: STAT_PERIODS.MONTH, label: 'Month' },
  { value: STAT_PERIODS.YEAR, label: 'Year' },
];

export const REMINDER_STATUS_COLORS = {
  ACTIVE: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', dot: 'bg-emerald-400' },
  PAUSED: { bg: 'bg-yellow-500/10', text: 'text-yellow-400', dot: 'bg-yellow-400' },
  COMPLETED: { bg: 'bg-gray-500/10', text: 'text-gray-400', dot: 'bg-gray-400' },
  FAILED: { bg: 'bg-red-500/10', text: 'text-red-400', dot: 'bg-red-400' },
};

export const REMINDER_TYPE_COLORS = {
  ONE_TIME: { bg: 'bg-sky-500/10', text: 'text-sky-400', bar: 'bg-sky-500' },
  REPEATING: { bg: 'bg-violet-500/10', text: 'text-violet-400', bar: 'bg-violet-500' },
};

export const REMINDER_FREQUENCY_COLORS = {
  DAILY: { bar: 'bg-sky-500' },
  WEEKLY: { bar: 'bg-indigo-500' },
  SEMI_MONTHLY: { bar: 'bg-violet-500' },
  MONTHLY: { bar: 'bg-purple-500' },
  ANNUAL: { bar: 'bg-fuchsia-500' },
};

export const LOG_STATUS_COLORS = {
  SUCCESS: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', dot: 'bg-emerald-400' },
  FAILED: { bg: 'bg-red-500/10', text: 'text-red-400', dot: 'bg-red-400' },
  EMAIL_FAILED: { bg: 'bg-red-500/10', text: 'text-red-400', dot: 'bg-red-400' },
  NOTIFICATION_FAILED: { bg: 'bg-orange-500/10', text: 'text-orange-400', dot: 'bg-orange-400' },
  WORKER_FAILED: { bg: 'bg-rose-500/10', text: 'text-rose-400', dot: 'bg-rose-400' },
  SKIPPED: { bg: 'bg-gray-500/10', text: 'text-gray-400', dot: 'bg-gray-400' },
};

export const TODO_STATUS_COLORS = {
  INPROGRESS: { bg: 'bg-blue-500/10', text: 'text-blue-400', bar: 'bg-blue-500' },
  PAUSED: { bg: 'bg-gray-500/10', text: 'text-gray-400', bar: 'bg-gray-500' },
  POSTPONED: { bg: 'bg-yellow-500/10', text: 'text-yellow-400', bar: 'bg-yellow-500' },
  DONE: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', bar: 'bg-emerald-500' },
};

export const TODO_PRIORITY_COLORS = {
  URGENT: { bg: 'bg-red-500/10', text: 'text-red-400', bar: 'bg-red-500' },
  HIGH: { bg: 'bg-yellow-500/10', text: 'text-yellow-400', bar: 'bg-yellow-500' },
  MEDIUM: { bg: 'bg-blue-500/10', text: 'text-blue-400', bar: 'bg-blue-500' },
  LOW: { bg: 'bg-emerald-500/10', text: 'text-emerald-400', bar: 'bg-emerald-500' },
};

export const TODO_ASSIGNMENT_COLORS = {
  ASSIGNED: { bar: 'bg-indigo-500' },
  CONTROLS: { bar: 'bg-sky-500' },
};
